export class BaseResponse {
  public HasError: boolean;
  public Errors: ErrorResponse[];
  public CreatedBy: string;
  public CreatedOn: Date;
  public ModifiedBy: string;
  public ModifiedOn: Date;

  static GetErrorMessage(response: BaseResponse): string {
    if (response.Errors != null && response.Errors.length > 0) {
      return response.Errors[0].ErrorMessage;
    } else {
      return '';
    }
  }
}
export class ErrorResponse {
  public ErrorCode: number;
  public ErrorMessage: string;
  public HasError: boolean;

  constructor(message: string, code = 'custom') {
    this.ErrorMessage = message;
    this.HasError = !!this.ErrorMessage?.length;
  }
}

export class SimpleResponse<T = any> extends BaseResponse {
  public Result: T;
  public rows?: T;
}

export class BaseListResponse<T = any> extends BaseResponse {
  public TotalRecords = 0;
  public CurrentPage = 1;
  public Result: T;
  public Headers: string[];
  public count = 0;
}

export class ListResponse<T = any> extends BaseListResponse {
  public TotalRecords = 0;
  public CurrentPage = 1;
  public Result: Array<T> = [];
  public Headers: string[];
}

export interface NodeSimpleResponse<T> {
  message: string;
  data: T;
  status: string;
  code: number;
  errors: any;
}

export interface NodeListResponseData<T> {
  count: number;
  rows: T[];
}
export interface NodeListResponseWithCount<T> {
  message: string;
  data: NodeListResponseData<T>;
  status: string;
  code: number;
  errors: any;
}
export interface NodeListResponseWithoutCount<T> {
  message: string;
  data: T[];
  status: string;
  code: number;
  errors: any;
}

export interface NodeListResponseWithData<T> {
  message: string;
  data: {
    data: T[];
    message: string;
  };
  status: string;
  code: number;
  errors: any;
}

export interface NodeListResponseWithRows<T> {
  message: string;
  data: {
    data: {
      rows: T[];
      count: number;
    };
    message: string;
  };
  status: string;
  code: number;
  errors: any;
}

export interface ExpressResponse<T> {
  // is success
  resp_status: boolean;
  // error code
  resp_code: string;
  // error in eng
  resp_msg: string;
  // response object
  resp_data: T;
}

/**
 * Upload response will contain list of filenames
 */
export type SimpleUploadResponse = SimpleResponse<string[]>;
